import { Component, Input, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-autofocus-input-group',
  templateUrl: './autofocus-input-group.component.html'
})
export class AutofocusInputGroupComponent implements OnInit, AfterViewInit {

  @Input() label!: string;
  @Input() control!: FormControl;
  @Input() type!: string;
  @ViewChildren('autoFocus') fc: any;


  ngOnInit(): void {
    this.type = this.type || 'text';
  }

  ngAfterViewInit(): void {
    this.fc.first.nativeElement.focus();
  }

}
